export const STATUS_FILTER_OPTIONS = [
  { value: "Chase", label: "Chase" },
  { value: "Signed Up", label: "Signed Up" },
  { value: "In Treatment", label: "In Treatment" },
  { value: "Discharged - Completed", label: "Discharged - Completed" },
  { value: "Discharged - Not Started", label: "Discharged - Not Started" },
  { value: "Never Signed Up", label: "Never Signed Up" },
  { value: "Cancelled", label: "Cancelled" },
  { value: "Closed Referral", label: "Closed Referral" },
];

// Options for the editable special_status field in the drawer/table
export const SPECIAL_STATUS_OPTIONS = [
  { value: "", label: "None" },
  ...STATUS_FILTER_OPTIONS,
];

export const SITE_FILTER_OPTIONS = [
  { value: "Bedford", label: "Bedford" },
  { value: "Greenwich", label: "Greenwich" },
  { value: "North Hampshire", label: "North Hampshire" },
  { value: "Rushcliffe", label: "Rushcliffe" },
  { value: "South & West Herts", label: "South & West Herts" },
];

export const URGENCY_FILTER_OPTIONS = [
  { value: "Routine", label: "Routine" },
  { value: "Urgent", label: "Urgent" },
  { value: "2 Week Wait", label: "2 Week Wait" },
];

export const PATIENT_STATE_FILTER_OPTIONS = [
  { value: "new", label: "New" },
  { value: "invited", label: "Invited" },
  { value: "in_first_health_form", label: "In First Health Form" },
  { value: "in_introduction", label: "In Introduction" },
  { value: "in_six_week_course", label: "In 6 Week Course" },
  { value: "in_sustain_course", label: "In Sustain Course" },
  { value: "in_custom_course", label: "In Custom Course" },
  { value: "in_selfcare", label: "In Selfcare" },
  { value: "discharged", label: "Discharged" },
  { value: "treatment_ended", label: "Treatment Ended" },
  { value: "explore", label: "Explore" },
];

export const JOINT_FILTER_OPTIONS = [
  { value: "left_knee", label: "Left Knee" },
  { value: "right_knee", label: "Right Knee" },
  { value: "bilateral_knee", label: "Bilateral Knee" },
  { value: "knee", label: "Knee (no side)" },
  { value: "left_hip", label: "Left Hip" },
  { value: "right_hip", label: "Right Hip" },
  { value: "bilateral_hip", label: "Bilateral Hip" },
  { value: "hip", label: "Hip (no side)" },
  { value: "left_shoulder", label: "Left Shoulder" },
  { value: "right_shoulder", label: "Right Shoulder" },
  { value: "bilateral_shoulder", label: "Bilateral Shoulder" },
  { value: "shoulder", label: "Shoulder (no side)" },
  { value: "left_foot", label: "Left Foot/Ankle" },
  { value: "right_foot", label: "Right Foot/Ankle" },
  { value: "bilateral_foot", label: "Bilateral Foot" },
  { value: "foot", label: "Foot (no side)" },
  { value: "left_hand", label: "Left Hand/Wrist" },
  { value: "right_hand", label: "Right Hand/Wrist" },
  { value: "bilateral_hand", label: "Bilateral Hand" },
  { value: "hand", label: "Hand (no side)" },
  { value: "left_elbow", label: "Left Elbow" },
  { value: "right_elbow", label: "Right Elbow" },
  { value: "bilateral_elbow", label: "Bilateral Elbow" },
  { value: "elbow", label: "Elbow (no side)" },
  { value: "lower_back", label: "Lower Back" },
  { value: "neck", label: "Neck" },
  { value: "left_lower_leg", label: "Left Lower Leg" },
  { value: "right_lower_leg", label: "Right Lower Leg" },
];

export const PAGE_SIZE_OPTIONS = [25, 50, 100, 200];

export const DATE_PRESETS = [
  { value: "", label: "All Time" },
  { value: "today", label: "Today" },
  { value: "this_week", label: "This Week" },
  { value: "last_30", label: "Last 30 Days" },
  { value: "last_90", label: "Last 90 Days" },
  { value: "custom", label: "Custom Range..." },
];

export interface ColumnDef {
  key: string;
  label: string;
  editable?: boolean;
  type?: "select" | "date" | "month" | "text";
  minWidth?: number;
  filterable?: boolean;
  sortable?: boolean;
}

// Slim columns shown in the main table — click a row to see full details in drawer
export const TABLE_COLUMNS: ColumnDef[] = [
  { key: "status", label: "Status", sortable: true, filterable: true, minWidth: 120 },
  { key: "special_status", label: "Special Status", editable: true, type: "select", filterable: true, minWidth: 160 },
  { key: "patient_name", label: "Patient", sortable: true, filterable: true, minWidth: 140 },
  { key: "patient_id", label: "Patient ID" },
  { key: "nhs_number", label: "NHS Number", sortable: true },
  { key: "site", label: "Site", sortable: true, filterable: true },
  { key: "urgency", label: "Urgency", filterable: true },
  { key: "referral_date", label: "Referral Date", sortable: true },
  { key: "invitation_sent_at", label: "Invite Sent" },
  { key: "signed_up_at", label: "Signed Up", sortable: true },
  { key: "therapist_name", label: "Therapist", filterable: true },
  { key: "current_course_week_number", label: "Week" },
  { key: "kickoff_date", label: "Kickoff Date", sortable: true },
  { key: "body_part_referred", label: "Body Part" },
  { key: "actual_joint", label: "Actual Joint" },
  { key: "wrong_joint", label: "Wrong Joint" },
  { key: "wrong_site", label: "Wrong Site" },
  { key: "state", label: "State", filterable: true },
  { key: "comments", label: "Comments", editable: true, type: "text", minWidth: 200 },
];

// Full column list used by the drawer, export, and filters
export const COLUMNS: ColumnDef[] = [
  { key: "status", label: "Status", filterable: true, minWidth: 120 },
  { key: "special_status", label: "Special Status", editable: true, type: "select", filterable: true, minWidth: 160 },
  { key: "patient_name", label: "Patient", filterable: true, minWidth: 140 },
  { key: "nhs_number", label: "NHS Number" },
  { key: "site", label: "Site", filterable: true },
  { key: "urgency", label: "Urgency", filterable: true },
  { key: "referral_date", label: "Referral Date" },
  { key: "referral_processed_at", label: "Processed" },
  { key: "invitation_sent_at", label: "Invite Sent" },
  { key: "referral_to_invite", label: "Days to Invite" },
  { key: "patient_dob", label: "DOB" },
  { key: "patient_email", label: "Email" },
  { key: "patient_phone_numbers", label: "Phone" },
  { key: "patient_address", label: "Address" },
  { key: "gp_details", label: "GP Details" },
  { key: "cic_pathway_ids", label: "Pathway ID" },
  { key: "body_part_referred", label: "Body Part", filterable: true },
  { key: "body_parts_referred", label: "Body Parts (All)" },
  { key: "invited_joint", label: "Invited Joint", filterable: true },
  { key: "actual_joint", label: "Actual Joint" },
  { key: "patient_id", label: "Patient ID" },
  { key: "signup_payer_name", label: "Signup Payer", filterable: true },
  { key: "current_payer_name", label: "Current Payer", filterable: true },
  { key: "therapist_name", label: "Therapist", filterable: true },
  { key: "signed_up_at", label: "Signed Up" },
  { key: "treatment_started_on", label: "Treatment Start" },
  { key: "current_course_week_number", label: "Week" },
  { key: "state", label: "State", filterable: true },
  { key: "wrong_joint", label: "Wrong Joint" },
  { key: "comments", label: "Comments", editable: true, type: "text", minWidth: 200 },
  { key: "notes", label: "Notes", editable: true, type: "text", minWidth: 200 },
  { key: "wrong_site", label: "Wrong Site" },
  { key: "kickoff_date", label: "Kickoff Date" },
  { key: "kickoff_booking_status", label: "Kickoff Status" },
  { key: "followup_date", label: "Followup Date" },
  { key: "followup_booking_status", label: "Followup Status" },
  { key: "discharge_date", label: "Discharge Date" },
  { key: "discharge_booking_status", label: "Discharge Status" },
  { key: "total_contacts", label: "Contacts" },
  { key: "last_activity_date", label: "Last Activity" },
  { key: "discharge_sent", label: "Discharge Sent", editable: true, type: "date" },
  { key: "invoice_submission_month", label: "Invoice Month", editable: true, type: "month" },
];
